export const en = {
    title: `Welcome back`,
    description: `Enter your credentials to sign in to your account`,
    forgotPassword: `Forgot your password?`,
    noAccount: `Don't have an account?`,
    failure: `Login failed`,
};
//# sourceMappingURL=en.js.map